import type { WithClassNameProp } from '@vlabs/uikit/types';
import classNames from 'classnames';

import './PageContent.sass';
import './LegacyHeight.sass';
import type { WithLegacyProp } from './legacyProp';

interface PageContentProps extends React.PropsWithChildren, WithClassNameProp, WithLegacyProp {}

function PageContent({
  children,
  legacy = false,
  className = undefined,
}: PageContentProps): React.JSX.Element {
  return (
    <div
      className={classNames(
        'PageContentV2',
        {
          'legacy-height': legacy,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

export { PageContent };
